"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerMonthSwitchButton = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _button = require("../../../button");
var _datePickerTheme = require("./datePickerTheme");
const DatePickerMonthSwitchButton = (0, _styled.default)(_button.Button)`
    height: 32px;
    width: 32px;

    // A secondary Button's text color, when enabled, would normally be a blueish color, but we want
    // it to be our standard font color. If the button is disabled, we want to keep the color the
    // same as the disabled color the button already uses.
    &:not([aria-disabled="true"]) {
        color: ${_datePickerTheme.datePickerTheme.color};
    }

    // This ensures the button focus outlines always show above their neighbors.
    z-index: 0;
    &:focus {
        z-index: 1;
    }
`;
exports.DatePickerMonthSwitchButton = DatePickerMonthSwitchButton;
//# sourceMappingURL=DatePickerMonthSwitchButton.js.map